import {MINUTE} from './commonConsts';

export enum DeliveryTrackerJobStatuses {
  Confirmed = 'Confirmed',
  Cooking = 'Cooking',
  Delivering = 'Delivering',
  EatingTime = 'EatingTime',
  Canceled = 'Canceled',
}

export const SortingDeliveryTrackerJobStatusesOrder = {
  [DeliveryTrackerJobStatuses.Canceled]: 4,
  [DeliveryTrackerJobStatuses.EatingTime]: 3,
  [DeliveryTrackerJobStatuses.Delivering]: 2,
  [DeliveryTrackerJobStatuses.Cooking]: 1,
  [DeliveryTrackerJobStatuses.Confirmed]: 0,
};

export enum DeliveryTrackerBarStatuses {
  FINISHED = 'finished', // orange fill
  ON_HOLD = 'onHold', // gray fill
  LOADING = 'loading', // animation is on!
}

export const DELIVERY_INTERVAL_TIME = MINUTE;
